import { FETCH_PURCHASE_ORDER, FETCH_PURCHASE_ORDER_FILTER, FETCH_PURCHASE_ORDER_LOADING, FETCH_PURCHASE_ORDER_NEW, FETCH_PURCHASE_ORDER_QUICK_SUMMARY, FETCH_PURCHASE_ORDER_QUICK_SUMMARY_NEW, PURCHASE_ORDER_QUICK_SUMMARY_LOADING,USER_ASSOCIATION_SUCCESS,USER_ASSOCIATION_ERROR,USER_ASSOCIATION_LOADING, PO_STATUS_LOADING, PO_STATUS_SUCCESS, PO_STATUS_ERROR, FETCH_SL_FROM_PO_DASHBOARD_LOADING, FETCH_SL_FROM_PO_DASHBOARD_SUCCESS, FETCH_SL_FROM_PO_DASHBOARD_ERROR, CLEAR_SL_FROM_PO_DASHBOARD  } from "../../actions/types";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_PURCHASE_ORDER:
      return {
        ...state,
        purchaseOrderDetails: action.payload,
      };
      case FETCH_PURCHASE_ORDER_NEW:
        return {
          ...state,
          purchaseOrderDetailsNew: action.payload,
        };
      case FETCH_PURCHASE_ORDER_LOADING:
        return {
          ...state,
          purchaseOrderDetailsLoading: action.payload,
      };
      case FETCH_PURCHASE_ORDER_FILTER:
        return {
          ...state,
          purchaseOrderDetailsFilters: action.payload,
      };
      case PURCHASE_ORDER_QUICK_SUMMARY_LOADING:
        return {
          ...state,
          poQuickSummaryLoading: action.payload,
      };
      case FETCH_PURCHASE_ORDER_QUICK_SUMMARY:
        return {
          ...state,
          poQuickSummary: action.payload,
      };
      case FETCH_PURCHASE_ORDER_QUICK_SUMMARY_NEW:
        return {
          ...state,
          poQuickSummaryNew: action.payload,
      };
      
    case USER_ASSOCIATION_SUCCESS:
      return { 
        ...state, 
        userAssociationResult: action.payload 
      };
    case USER_ASSOCIATION_ERROR:
      return { 
        ...state, 
        userAssociationError: action.error 
      };
    case USER_ASSOCIATION_LOADING:
      return { 
        ...state, 
        userAssociationLoading: action.payload 
      };
      
    case PO_STATUS_SUCCESS:
      return { 
        ...state, 
        poStatusData: action.payload 
      };
    case PO_STATUS_ERROR:
      return { 
        ...state, 
        poStatusError: action.error 
      };
    case PO_STATUS_LOADING:
      return { 
        ...state, 
        poStatusLoading: action.payload 
      };

   
    case FETCH_SL_FROM_PO_DASHBOARD_SUCCESS:
      return { 
        ...state, 
        slDetailsFromPODashboard: {
          ...state.slDetailsFromPODashboard,
          [action.payload.schrockenSLID]: action.payload.data
        }
      };
    case FETCH_SL_FROM_PO_DASHBOARD_ERROR:
      return { 
        ...state, 
        slDetailsFromPODashboardError: action.error 
      };
    case FETCH_SL_FROM_PO_DASHBOARD_LOADING:
      return { 
        ...state, 
        slDetailsFromPODashboardLoading: action.payload 
      };
    case CLEAR_SL_FROM_PO_DASHBOARD:
      // Clear specific SL data if payload is provided, otherwise clear all
      if (action.payload) {
        const { [action.payload]: removed, ...rest } = state.slDetailsFromPODashboard || {};
        return {
          ...state,
          slDetailsFromPODashboard: rest
        };
      }
      // Clear all SL details
      return {
        ...state,
        slDetailsFromPODashboard: {}
      };
      
    default:
      return state;
  }
}
